var _g, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileProgressArrowActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 73.582,
    r: 11,
    fill: "#10C98E"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 23.5,
    cy: 73.582,
    r: 14.75,
    stroke: "#10C98E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 23.5,
    cy: 73.582,
    r: 22.75,
    stroke: "#10C98E",
    strokeWidth: 0.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 23.5,
    cy: 6.059,
    r: 5,
    stroke: "#10C98E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.5 37.68l6.145 6.145 6.144-6.144",
    stroke: "#10C98E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.5 11.06v32",
    stroke: "#10C98E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
}
export default SvgMobileProgressArrowActive;